// The small green dot that says "this is coming in live". It is a still shape with a ring, not a
// pulse, so it needs no reduced-motion variant; the word "live" is the consuming row's job.
import "./config";
import { View } from "tamagui";

export function LiveDot(): React.JSX.Element {
  return (
    <View
      aria-hidden
      data-live-dot
      flexShrink={0}
      width={8}
      height={8}
      borderRadius="pill"
      backgroundColor="ready"
      borderWidth={{ default: 0, a11yLight: 2, a11yDark: 2 }}
      borderColor="text"
      outlineWidth={3}
      outlineStyle="solid"
      outlineColor="readyBg"
    />
  );
}
